import { render, staticRenderFns } from "./szrsy.vue?vue&type=template&id=84dac612&scoped=true&"
import script from "./szrsy.vue?vue&type=script&lang=js&"
export * from "./szrsy.vue?vue&type=script&lang=js&"
import style0 from "./szrsy.vue?vue&type=style&index=0&id=84dac612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84dac612",
  null
  
)

export default component.exports